import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router";
import { getIsUtahParticipant } from "~/participant/utils/getIsUtahParticipant.helpers";
import { JOBS_QUERIES } from "~/shared/api/jobs/jobs.queries";
import { notFound } from "~/shared/util/notFound";

export async function jobGamePlansViewLoader({ params }: LoaderFunctionArgs, queryClient: QueryClient) {
  const isUtahParticipant = await getIsUtahParticipant(queryClient);
  const { gamePlanId } = params;

  if (isUtahParticipant || !gamePlanId) {
    return notFound();
  }

  queryClient.prefetchQuery(JOBS_QUERIES.member.gameplanDetail(gamePlanId));
}
